import { UAParser } from 'ua-parser-js';

const APP_SCHEME = 'sorra://';
export const IOS_APP_STORE_URL =
  'https://apps.apple.com/us/app/sorra/id6746782156';
export const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=net.sorra.androidapp';

// Returns 'ios' | 'android' | null using ua-parser-js for precise device/OS detection.
export const getMobileOS = () => {
  if (typeof window === 'undefined' || !window.navigator) return null;

  const { os, device } = UAParser(window.navigator.userAgent);

  if (device.type !== 'mobile' && device.type !== 'tablet') return null;

  const osName = (os.name || '').toLowerCase();
  if (osName === 'ios') return 'ios';
  if (osName === 'android') return 'android';

  return null;
};

export const isMobileDevice = () => getMobileOS() !== null;

export const getAppStoreUrl = () => {
  const os = getMobileOS();
  if (os === 'ios') return IOS_APP_STORE_URL;
  if (os === 'android') return ANDROID_PLAY_STORE_URL;
  return null;
};

// Attempts to open the app via its URL scheme on mobile devices. If the app
// isn't installed (the page stays visible after a short delay), falls back
// to the appropriate app store / Google Play listing.
export const openAppOrStore = (path = '') => {
  if (typeof window === 'undefined') return;

  const os = getMobileOS();
  if (!os) return;

  const storeUrl = os === 'ios' ? IOS_APP_STORE_URL : ANDROID_PLAY_STORE_URL;
  const schemeUrl = `${APP_SCHEME}${path}`;

  const clearFallback = () => {
    clearTimeout(fallbackTimer);
    document.removeEventListener('visibilitychange', onVisibilityChange);
    window.removeEventListener('pagehide', clearFallback);
  };

  const onVisibilityChange = () => {
    if (document.hidden) {
      clearFallback();
    }
  };

  const fallbackTimer = setTimeout(() => {
    clearFallback();
    if (!document.hidden) {
      window.location.href = storeUrl;
    }
  }, 1500);

  document.addEventListener('visibilitychange', onVisibilityChange);
  window.addEventListener('pagehide', clearFallback);

  window.location.href = schemeUrl;
};
